import Layout from "../components/Layout";
import { API_BASE } from "../api/config";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";

function Checkout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { username, branch } = useAuth();
  const [tables, setTables] = useState([]);
  const [selectedTable, setSelectedTable] = useState(null);
  const [kotItems, setKotItems] = useState([]);
  const [loadingKot, setLoadingKot] = useState(false);
  const [branchDetails, setBranchDetails] = useState(null);
  const [companyDetails, setCompanyDetails] = useState(null);
  const [paymentModes, setPaymentModes] = useState([]);

  const [billing, setBilling] = useState({
    name: "",
    mobile: "",
    personal_number: "", // ✅ ADDED personal_number field
    gstin: "",
    member_ship: "",
    address: "",
    discount: 0,
    couponCode: "",
    couponDiscount: 0,
    additionalCharge: 0,
    paymentMode: "Cash",
    cash: 0,
    online_cash: 0,
    bill_reference: "",
  });

  const [modalMessage, setModalMessage] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [couponApplied, setCouponApplied] = useState(false);
  const [processing, setProcessing] = useState(false);
  
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);

  useEffect(() => {
    setSelectedTable(null);
    setKotItems([]);
  }, [selectedBranch]);

  useEffect(() => {
    if (location.state) {
      if (location.state.branch) setSelectedBranch(location.state.branch);
    }
  }, []);

  useEffect(() => {
    if (
      location.state &&
      location.state.table &&
      typeof location.state.table === "string" &&
      tables.length > 0
    ) {
      const foundTable = tables.find(
        (t) => t.table_name === location.state.table
      );
      if (foundTable) {
        handleSelectTable(foundTable);
      }
    }
  }, [tables, location.state]);

  // ✅ Auto-populate billing info including personal_number from KOT items
  useEffect(() => {
    if (kotItems.length > 0) {
      setBilling((prev) => ({
        ...prev,
        mobile: kotItems[0].mobile || prev.mobile,
        member_ship: kotItems[0].member_ship || prev.member_ship,
        personal_number: kotItems[0].personal_number || prev.personal_number, // ✅ ADDED auto-fill
      }));
    }
  }, [kotItems]);

  useEffect(() => {
    fetch(
      `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=branches`
    )
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) setBranches(data);
      })
      .catch((err) => console.error("Error fetching branches:", err));
  }, []);

  // ✅ Fetch Branch Details
  useEffect(() => {
    fetch(
      `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=branches&condition=get_branch_det&branch=${selectedBranch}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) setBranchDetails(data[0]);
      })
      .catch((err) => console.error("Error fetching branch details:", err));
  }, [branch]);
  
  useEffect(() => {
    setSelectedTable(null);
  }, [selectedBranch]);

  // ✅ Fetch Tables
  useEffect(() => {
    if (!selectedBranch) {
      setTables([]);
      return;
    }

    fetch(
      `${API_BASE}?key=dzital_key&pswd=Hibujji@123&table=get_active_table&transac=get_table_kot&condition=branch&branch=${selectedBranch}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data?.status === "success") {
          setTables(data.data || []);
        } else {
          setTables([]);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch tables:", err);
        setTables([]);
      });
  }, [selectedBranch]);

  // ✅ Fetch Company Details
  useEffect(() => {
    fetch(`${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=company`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.status === "ok" && data.data?.length > 0) {
          setCompanyDetails(data.data[0]);
        }
      })
      .catch((err) => console.error("Error fetching company details:", err));
  }, []);

  // ✅ Fetch Payment Modes
  useEffect(() => {
    fetch(
      `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=payment_modes&condition=status`
    )
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setPaymentModes(data);
        } else {
          console.error("Unexpected response format:", data);
        }
      })
      .catch((err) => console.error("Error fetching payment modes:", err));
  }, []);

  const fetchKotDetails = async (tableName) => {
    setLoadingKot(true);
    try {
      const res = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&table=get_kot_details_by_table&transac=get_table_kot&table_name_url=${encodeURIComponent(
          tableName
        )}&condition=branch&branch=${selectedBranch}`
      );
      const data = await res.json();
      setKotItems(data?.status === "success" ? data.data : []);
    } catch (err) {
      console.error("Error fetching KOT:", err);
      setKotItems([]);
    }
    setLoadingKot(false);
  };

  const handleSelectTable = (table) => {
    setSelectedTable(table);
    fetchKotDetails(table.table_name);
    fetchAdditionalCharge(table.table_id);
  };

  const handleChange = (e) =>
    setBilling({ ...billing, [e.target.name]: e.target.value });

  const handleApplyCoupon = () => {
    if (billing.couponCode.toLowerCase() === "welcome100") {
      setBilling({ ...billing, couponDiscount: 100 });
      setModalMessage("🎉 Coupon applied: ₹100 off");
      setCouponApplied(true);
    } else {
      setBilling({ ...billing, couponDiscount: 0 });
      setModalMessage("❌ Invalid coupon");
      setCouponApplied(false);
    }
    setModalVisible(true);
  };

  useEffect(() => {
    if (modalVisible) {
      const timer = setTimeout(() => setModalVisible(false), 2500);
      return () => clearTimeout(timer);
    }
  }, [modalVisible]);

  const gstEnabled = branchDetails?.gst_bill === "Yes";
  const itemPriceField = gstEnabled ? "item_taxable_price" : "item_price";

  const subtotal = kotItems.reduce((sum, i) => sum + Number(i.total_amount || 0), 0);
  const taxable_value = gstEnabled
    ? kotItems.reduce((sum, i) => sum + Number(i.total_taxable_value || 0), 0)
    : 0;
  const tax_value = gstEnabled
    ? kotItems.reduce((sum, i) => sum + Number(i.total_tax_value || 0), 0)
    : 0;

  const discountAmount = (subtotal * billing.discount) / 100;
  const additionalChargeAmount = (subtotal * billing.additionalCharge) / 100;
  const grandTotalRaw =
    subtotal - discountAmount - billing.couponDiscount + additionalChargeAmount;
  const roundOff = Math.round(grandTotalRaw) - grandTotalRaw;
  const grandTotal = Math.round(grandTotalRaw);

  const totalItems = kotItems.reduce((sum, i) => sum + Number(i.item_qty || 0), 0);
  const formatMoney = (value) => Number(value).toFixed(2);
  
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  const dd = String(now.getDate()).padStart(2, "0");
  const hh = String(now.getHours()).padStart(2, "0");
  const min = String(now.getMinutes()).padStart(2, "0");
  const ss = String(now.getSeconds()).padStart(2, "0");
  const ms = String(now.getMilliseconds()).padStart(3, "0");
  const rand = Math.floor(1000 + Math.random() * 9000);
  const transaction_number = `${yyyy}${mm}${dd}${hh}${min}${ss}${ms}${rand}`;

  const submitBilling = async () => {
    if (!selectedTable) return;

    const payload = {
      transaction_number: transaction_number,
      table_id: selectedTable.table_id,
      table_name: selectedTable.table_name,
      customer_name: billing.name,
      customer_mobile: billing.mobile,
      personal_number: billing.personal_number, // ✅ ADDED to billing submission payload
      customer_gstin: billing.gstin,
      member_ship: billing.member_ship,
      bill_reference: billing.bill_reference,
      discount: Number(billing.discount).toFixed(2),
      coupon_code: billing.couponCode,
      coupon_discount: Number(billing.couponDiscount).toFixed(2),
      additional_charge: Number(billing.additionalCharge).toFixed(2),
      additional_charge_amount: Number(additionalChargeAmount).toFixed(2),
      payment_mode: billing.paymentMode,
      cash: Number(billing.cash).toFixed(2),
      online_cash: Number(billing.online_cash).toFixed(2),
      round_off: Number(roundOff).toFixed(2),
      subtotal: formatMoney(subtotal),
      discount_amount: formatMoney(discountAmount),
      grand_total: formatMoney(grandTotal),
      total_items: totalItems,
      gst_bill: gstEnabled ? "Yes" : "No",
      date: new Date().toISOString(),
      kot_items: kotItems.map((item) => ({
        item_name: item.item_name,
        item_qty: item.item_qty,
        group_name: item.group_name,
        branch: item.branch,
        item_price: Number(item[itemPriceField]).toFixed(2),
        total: (item.item_qty * item[itemPriceField]).toFixed(2),
        item_additional_member_ship: item.additional_member_ship,
      })),
    };
    
    const kotBranch = kotItems.length > 0 ? kotItems[0].branch : "";

    try {
      const res = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=billing_submit&username=${username}&branch=${kotBranch}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
      const data = await res.json();
      console.log("Billing submitted:", data);
    } catch (err) {
      console.error("Error submitting billing:", err);
    }
  };
  
  const fetchAdditionalCharge = async (tableId) => {
    try {
      const res = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&branch=${branch}&table=tables`
      );
      const data = await res.json();

      if (Array.isArray(data)) {
        const selected = data.find(
          (t) => String(t.table_id) === String(tableId)
        );

        if (selected && selected.additional_charge_per) {
          setBilling((prev) => ({
            ...prev,
            additionalCharge: Number(selected.additional_charge_per),
          }));
        }
      }
    } catch (error) {
      console.error("Error fetching additional charge:", error);
    }
  };

  const handlePrintBill = async (prePrint = false) => {
    if (processing) return;
    setProcessing(true);

    if (!prePrint) await submitBilling();
    if (!selectedTable) return;

    const now = new Date();
    const dateTime = now.toLocaleString();
    const footerNote = `Generated by ${username} @ ${branch}`;

    let receipt = "";

    const formatLine = (name, qty, amt) => {
      const itemWidth = 28;
      const qtyWidth = 6;
      const amtWidth = 14;

      const item = name.substring(0, itemWidth).padEnd(itemWidth, " ");
      const quantity = String(qty).padStart(qtyWidth, " ");
      const amount = String(amt).padStart(amtWidth, " ");

      return item + quantity + amount + "\n";
    };

    const divider = "------------------------------------------------\n";

    receipt += "\x1B\x61\x01";
    receipt += (branchDetails?.name || "Restaurant Name") + "\n";
    receipt += (branchDetails?.address || "") + "\n";
    receipt += divider;
    receipt += (prePrint ? "PRE BILL\n" : "FINAL BILL\n");
    receipt += "\x1B\x61\x00";
    receipt += divider;

    receipt += "Table  : " + selectedTable.table_name + "\n";
    receipt += "Date   : " + dateTime + "\n";

    if (!prePrint)
      receipt += "Order  : " + transaction_number + "\n";

    if (billing.name)
      receipt += "Name   : " + billing.name + "\n";

    if (billing.mobile)
      receipt += "Mobile : " + billing.mobile + "\n";

    if (billing.personal_number)
      receipt += "Personal No : " + billing.personal_number + "\n"; // Optional receipt print inclusion

    if (billing.member_ship)
      receipt += "Member : " + billing.member_ship + "\n";

    if (billing.gstin)
      receipt += "GSTIN  : " + billing.gstin + "\n";

    receipt += divider;

    receipt += formatLine("Item", "Qty", "Amount");
    receipt += divider;

    Object.entries(groupedByCourse).forEach(([course, items]) => {
      receipt += "\x1B\x61\x01";
      receipt += "---- " + course.toUpperCase() + " ----\n";
      receipt += "\x1B\x61\x00";
      receipt += divider;

      items.forEach((item) => {
        const total = formatMoney(item.item_qty * item[itemPriceField]);
        receipt += formatLine(item.item_name, item.item_qty, total);
      });

      const courseTotal = items.reduce(
        (sum, i) => sum + i.item_qty * i[itemPriceField],
        0
      );

      receipt += divider;
      receipt +=
        course.toUpperCase() +
        " Subtotal : " +
        formatMoney(courseTotal) +
        "\n";

      receipt += divider;
    });

    receipt += divider;

    receipt += "Subtotal     : " + formatMoney(subtotal) + "\n";

    if (gstEnabled) {
      receipt += "Taxable      : " + formatMoney(taxable_value) + "\n";
      receipt += "Tax          : " + formatMoney(tax_value) + "\n";
    }

    if (discountAmount > 0)
      receipt += "Discount     : -" + formatMoney(discountAmount) + "\n";

    if (billing.couponDiscount > 0)
      receipt += "Coupon Disc  : -" + formatMoney(billing.couponDiscount) + "\n";

    if (additionalChargeAmount > 0)
      receipt += "Add. Charge  : " + formatMoney(additionalChargeAmount) + "\n";

    if (roundOff !== 0)
      receipt += "Round Off    : " + formatMoney(roundOff) + "\n";

    receipt += divider;

    receipt += "\x1B\x61\x01";
    receipt += "\x1B\x21\x30";
    receipt += "GRAND TOTAL\n";
    receipt += "Rs " + formatMoney(grandTotal) + "\n";
    receipt += "\x1B\x21\x00";
    receipt += "\x1B\x61\x00";

    receipt += divider;

    receipt += "Payment Mode : " + billing.paymentMode + "\n";

    if (billing.cash > 0)
      receipt += "Cash         : " + formatMoney(billing.cash) + "\n";

    if (billing.online_cash > 0)
      receipt += "Online       : " + formatMoney(billing.online_cash) + "\n";

    if (
      billing.paymentMode !== "Cash" &&
      billing.bill_reference &&
      billing.bill_reference.trim() !== ""
    ) {
      receipt += "Ref No       : " + billing.bill_reference + "\n";
    }

    receipt += divider;

    receipt += "\x1B\x61\x01";
    receipt += "Thank You Visit Again\n";
    receipt += "\x1B\x61\x00";

    receipt += footerNote + "\n\n\n";
    receipt += "\x1D\x56\x00";

    window.location.href =
      "rawbt://print?text=" + encodeURIComponent(receipt);

    setTimeout(() => {
      setProcessing(false);
      if (!prePrint) navigate("/kots-by-kitchen");
    }, 1500);
  };

  const resetAll = () => {
    setSelectedTable(null);
    setKotItems([]);
    setBilling({
      name: "",
      mobile: "",
      personal_number: "",
      gstin: "",
      member_ship: "",
      address: "",
      discount: 0,
      couponCode: "",
      couponDiscount: 0,
      additionalCharge: 0,
      paymentMode: "Cash",
      cash: 0,
      online_cash: 0,
      bill_reference: "",
    });
    setCouponApplied(false);
  };

  const groupedByCourse = kotItems.reduce((acc, item) => {
    const course = item.course_name || "Others";

    if (!acc[course]) {
      acc[course] = [];
    }

    acc[course].push(item);
    return acc;
  }, {});

  return (
    <Layout>
      <div className="min-h-screen bg-black text-white p-6">
        <div className="max-w-6xl mx-auto bg-black/80 backdrop-blur-lg rounded-2xl shadow-2xl p-8 border border-blue-700">
          
          {/* 🔵 Branch Selection */}
          <div className="mb-6">
            <h2 className="text-xl font-semibold text-blue-300 mb-4">
              Select Branch
            </h2>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {branches.map((b, i) => {
                const branchName = b.branch || b.name;
                const isActive = branchName === selectedBranch;

                return (
                  <div
                    key={i}
                    onClick={() => setSelectedBranch(branchName)}
                    className={`p-4 rounded-lg cursor-pointer border transition ${
                      isActive
                        ? "bg-green-700/40 border-green-400 scale-105"
                        : "bg-blue-950 border-blue-600 hover:bg-blue-900"
                    }`}
                  >
                    <h3 className="font-bold text-sm">{b.name || b.branch}</h3>
                    <p className="text-xs text-gray-300">{b.address || "—"}</p>

                    {isActive && (
                      <span className="inline-block mt-2 text-[10px] px-2 py-0.5 bg-green-500 text-black rounded">
                        Selected
                      </span>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
          
          {!selectedTable ? (
            <>
              <h2 className="text-xl font-semibold text-blue-300 mb-4">Select a Table</h2>
              <div className="grid grid-cols-3 md:grid-cols-4 gap-3">
                {tables.map((t) => (
                  <button
                    key={t.table_id}
                    onClick={() => handleSelectTable(t)}
                    className="bg-gradient-to-br from-blue-950 to-black hover:from-blue-900 hover:to-black text-white p-4 rounded-lg border border-blue-600 shadow"
                  >
                    <div className="text-sm font-bold">{t.table_name}</div>
                    <div
                      className={`mt-1 text-xs ${
                        t.table_booked_status === "0" ? "text-green-400" : "text-red-400"
                      }`}
                    >
                      Occupied
                    </div>
                  </button>
                ))}
              </div>
            </>
          ) : (
            <div className="grid md:grid-cols-2 gap-6">
              {/* Customer Info */}
              <div>
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-semibold text-blue-300">
                    Checkout - {selectedTable.table_name}
                  </h2>
                  <button
                    onClick={resetAll}
                    className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded"
                  >
                    Back to Tables
                  </button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <input
                    type="text"
                    name="name"
                    value={billing.name}
                    onChange={handleChange}
                    placeholder="Customer Name"
                    className="w-full bg-blue-950 text-white border border-blue-600 p-2 rounded text-sm"
                  />
                  <input
                    type="text"
                    name="mobile"
                    value={billing.mobile}
                    onChange={handleChange}
                    placeholder="Mobile Number"
                    className="w-full bg-blue-950 text-white border border-blue-600 p-2 rounded text-sm"
                  />
                  
                  {/* ✅ ADDED personal_number input field right before GSTIN */}
                  <input
                    type="text"
                    name="personal_number"
                    value={billing.personal_number}
                    onChange={handleChange}
                    placeholder="Personal Number"
                    className="w-full bg-blue-950 text-white border border-blue-600 p-2 rounded text-sm"
                  />

                  <input
                    type="text"
                    name="gstin"
                    value={billing.gstin}
                    onChange={handleChange}
                    placeholder="GSTIN"
                    className="w-full bg-blue-950 text-white border border-blue-600 p-2 rounded text-sm"
                  />

                  <input
                    type="text"
                    name="member_ship"
                    value={billing.member_ship}
                    onChange={handleChange}
                    placeholder="Membership"
                    className="w-full bg-blue-950 text-white border border-blue-600 p-2 rounded text-sm"
                  />

                  <input
                    type="number"
                    name="discount"
                    value={billing.discount || ""}
                    onChange={handleChange}
                    placeholder="Discount %"
                    className="w-full bg-blue-950 text-white border border-blue-600 p-2 rounded text-sm"
                  />

                  <div className="col-span-2 flex flex-col sm:flex-row gap-2">
                    <input
                      type="text"
                      name="couponCode"
                      value={billing.couponCode}
                      onChange={handleChange}
                      placeholder="Enter Coupon Code"
                      readOnly={couponApplied}
                      className={`flex-1 bg-blue-950 text-white border border-blue-600 p-2 rounded text-sm ${
                        couponApplied ? "opacity-60 cursor-not-allowed" : ""
                      }`}
                    />
                    <button
                      onClick={handleApplyCoupon}
                      disabled={couponApplied}
                      className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm"
                    >
                      Apply
                    </button>
                  </div>

                  <input
                    type="number"
                    name="additionalCharge"
                    value={billing.additionalCharge || ""}
                    onChange={handleChange}
                    placeholder="Additional Charge %"
                    className="w-full bg-blue-950 text-white border border-blue-600 p-2 rounded text-sm mt-2"
                  />
                  
                  <select
                    name="paymentMode"
                    value={billing.paymentMode}
                    onChange={handleChange}
                    className="w-full bg-blue-950 text-white border border-blue-600 p-2 rounded text-sm mt-2"
                  >
                    {paymentModes.length > 0 ? (
                      paymentModes.map((mode) => (
                        <option key={mode.id} value={mode.name}>
                          {mode.name}
                        </option>
                      ))
                    ) : (
                      <option>Loading...</option>
                    )}
                  </select>

                  {/* Payment Fields */}
                  <input
                    type="number"
                    name="cash"
                    value={billing.cash || ""}
                    onChange={handleChange}
                    placeholder="Cash Paid"
                    className="w-full bg-blue-950 text-white border border-blue-600 p-2 rounded text-sm"
                  />

                  {billing.paymentMode !== "Cash" && (
                    <>
                      <input
                        type="number"
                        name="online_cash"
                        value={billing.online_cash || ""}
                        onChange={handleChange}
                        placeholder="Online Paid"
                        className="w-full bg-blue-950 text-white border border-blue-600 p-2 rounded text-sm"
                      />
                      <input
                        type="text"
                        name="bill_reference"
                        value={billing.bill_reference || ""}
                        onChange={handleChange}
                        placeholder="Bill Reference"
                        className="w-full bg-blue-950 text-white border border-blue-600 p-2 rounded text-sm"
                      />
                    </>
                  )}

                </div>
              </div>

              {/* Order Summary */}
              <div>
                <h2 className="text-xl font-semibold text-blue-300 mb-3">
                  Order Summary
                </h2>
                {loadingKot ? (
                  <p className="text-gray-400">Loading items...</p>
                ) : kotItems.length === 0 ? (
                  <p className="text-gray-400">No items found for this table.</p>
                ) : (
                  <>
                    <div className="absolute top-0 right-0 bg-blue-600 text-white px-3 py-1 rounded-full shadow-lg z-10 text-sm">
                      Total Items: {totalItems}
                    </div>
                    {Object.entries(groupedByCourse).map(([course, items]) => (
                      <div key={course} className="mb-6">

                        <h3 className="text-md font-bold text-yellow-400 mb-2">
                          {course.toUpperCase()}
                        </h3>

                        <div className="max-h-64 overflow-y-auto border border-blue-600 rounded">
                          <table className="w-full text-left text-sm">
                            <thead className="bg-blue-800/60 sticky top-0">
                              <tr>
                                <th className="p-2">Item</th>
                                <th className="p-2 text-center">Qty</th>
                                <th className="p-2 text-right">Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              {items.map((item, idx) => (
                                <tr
                                  key={idx}
                                  className="border-t border-blue-700 bg-blue-800/40"
                                >
                                  <td className="p-2">{item.item_name}</td>
                                  <td className="p-2 text-center">{item.item_qty}</td>
                                  <td className="p-2 text-right">
                                    ₹{formatMoney(item.item_qty * item[itemPriceField])}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                      </div>
                    ))}

                    <div className="mt-4 text-sm bg-blue-950/50 p-3 rounded-lg border border-blue-700 text-right">
                      {gstEnabled && (
                        <>
                          <p>Taxable: ₹{formatMoney(taxable_value)}</p>
                          <p>Tax (CGST+SGST): ₹{formatMoney(tax_value)}</p>
                        </>
                      )}
                      <p>Subtotal: ₹{formatMoney(subtotal)}</p>
                      <p>Discount: -₹{formatMoney(discountAmount)}</p>
                      <p>Coupon: -₹{formatMoney(billing.couponDiscount)}</p>
                      <p>Additional Charge: +₹{formatMoney(additionalChargeAmount)}</p>
                      <p>Round Off: ₹{formatMoney(roundOff)}</p>
                      <p className="text-lg font-bold text-green-400 mt-2">
                        Grand Total: ₹{formatMoney(grandTotal)}
                      </p>
                    </div>
                    <div className="mt-6 flex flex-wrap gap-3">
                      <button
                        onClick={() => handlePrintBill(true)}
                        disabled={processing}
                        className="bg-yellow-600 hover:bg-yellow-700 text-white px-4 py-2 rounded"
                      >
                        {processing ? "Processing..." : "Pre-Print Bill"}
                      </button>
                      <button
                        onClick={() => handlePrintBill(false)}
                        disabled={processing}
                        className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
                      >
                        {processing ? "Processing..." : "Finalize & Print Bill"}
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {modalVisible && (
        <div className="fixed bottom-6 right-6 bg-gray-800 text-white px-4 py-2 rounded shadow-lg animate-fade-in">
          {modalMessage}
        </div>
      )}
    </Layout>
  );
}

export default Checkout;